var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsIn, IsOptional, IsString, IsUrl } from 'class-validator';
import { MediaSummary } from '../../commons/medias/media';
import { BookmarkTypeValues } from './bookmark-type';
/**
 * Affected endpoints
 * GET /manfredite/bookmarks
 * POST /manfredite/bookmarks/<id>
 * PUT /manfredite/bookmarks/<id>
 */
export class BookmarkResponse {
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BookmarkResponse.prototype, "id", void 0);
__decorate([
    Expose(),
    IsIn(BookmarkTypeValues),
    __metadata("design:type", String)
], BookmarkResponse.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], BookmarkResponse.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], BookmarkResponse.prototype, "category", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], BookmarkResponse.prototype, "author", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], BookmarkResponse.prototype, "description", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", MediaSummary)
], BookmarkResponse.prototype, "image", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    IsUrl({ require_protocol: true }),
    __metadata("design:type", String)
], BookmarkResponse.prototype, "url", void 0);
//# sourceMappingURL=bookmark.response.js.map